<div class="agent-page p-4" *ngIf="agent">
	<div class="flex items-center mb-4 border-b pb-3">
		<nz-avatar nzSize="large" nzIcon="user"></nz-avatar>
		<div class="ml-3">
			<h2 class="text-xl font-bold mb-1">{{ agent.firstName }} {{ agent?.lastName }}</h2>
			<p class="text-gray-500">
				Agent ID: {{ agent.id }} • Status: <i class="text-success">Active</i>
			</p>
			<p class="text-gray-400 text-sm">
				Created: {{ agent.createdAt | date }}
			</p>
		</div>
		<div class="ml-auto">
			<a nz-button nzType="default" class="mr-2" [routerLink]="['/agent','admin',agent.id,'edit']">Edit</a>
		</div>
	</div>

	<!-- Tabs -->
	<nz-tabset nzType="card">
		<nz-tab nzTitle="Details">
			<app-agent-view-details [agent]="agent"></app-agent-view-details>
		</nz-tab>
		<nz-tab nzTitle="App Roles/Permissions" *hasPermission="['RoleList']">
			<app-agent-admin-view-app-roles [agent]="agent"></app-agent-admin-view-app-roles>
		</nz-tab>
		<nz-tab nzTitle="Ticket Roles" *hasPermission="['WorkflowManageRoles']">
			<app-agent-admin-view-ticket-roles [agent]="agent"></app-agent-admin-view-ticket-roles>
		</nz-tab>
		<nz-tab nzTitle="Tickets" *hasPermission="['Ticket','TicketAdmin']">
			<app-agent-view-tickets [agent]="agent"></app-agent-view-tickets>
		</nz-tab>
	</nz-tabset>
</div>
